import { createContext, Dispatch, SetStateAction } from "react";

export const CockpitContext = createContext<{
  metric: string;
  setMetric: Dispatch<SetStateAction<string>>;
  //@ts-ignore
}>({ metric: "" });
